import React from "react"

import { AwardsGrid, AwardsText, HappiestWorkplacesButton } from "../../styles"
import HappiestWorkplacesForYouButton from "../HappiestWorkplacesForYouButton"
import AwardsYearFilter from "./AwardYearFilter"
import AwardsCategoryFilter from "./AwardsCategoryFilter"
import AwardsCountryFilter from "./AwardsCountryFilter"
import AwardsIndustryFilter from "./AwardsIndustryFilter"
import AwardsSearchInput from "./AwardsSearchInput"

const BannerActionsContainer = () => {
  return (
    <AwardsGrid>
      <AwardsSearchInput />
      <AwardsText color="primary.0">Filter by:</AwardsText>
      <AwardsCategoryFilter />
      <AwardsCountryFilter />
      <AwardsIndustryFilter />
      <AwardsYearFilter />
      <HappiestWorkplacesButton>
        <HappiestWorkplacesForYouButton />
      </HappiestWorkplacesButton>
    </AwardsGrid>
  )
}

export default BannerActionsContainer
